__turbopack_context__.v({
  "aiChip": "lPAfeW_aiChip",
  "aiChipsList": "lPAfeW_aiChipsList",
  "aiChipsRow": "lPAfeW_aiChipsRow",
  "aiChipsScrollButton": "lPAfeW_aiChipsScrollButton",
  "aiChipsScrollButtonLeft": "lPAfeW_aiChipsScrollButtonLeft",
  "aiChipsScrollButtonRight": "lPAfeW_aiChipsScrollButtonRight",
  "autogenInfoRowContainer": "lPAfeW_autogenInfoRowContainer",
  "autogenVariant": "lPAfeW_autogenVariant",
  "baseClass": "lPAfeW_baseClass",
  "chipsContainer": "lPAfeW_chipsContainer",
  "gradient": "lPAfeW_gradient",
  "gradientLeft": "lPAfeW_gradientLeft",
  "gradientRight": "lPAfeW_gradientRight",
  "headline": "lPAfeW_headline",
  "infoContainer": "lPAfeW_infoContainer",
  "inlineLink": "lPAfeW_inlineLink",
  "linksContainer": "lPAfeW_linksContainer",
  "lipaChip": "lPAfeW_lipaChip",
  "mapSwitch": "lPAfeW_mapSwitch",
  "resultsGroup": "lPAfeW_resultsGroup",
  "scrollingContainer": "lPAfeW_scrollingContainer",
});
